import(/* webpackMode: "eager" */ "/builder/src/app/error.tsx");
